import React from "react";
import {Asset, Link} from "../../../plugins/gatsby-plugin-atollon";
import parse from "html-react-parser";
import {RightArrow, SolidPlay, Download} from "../icons";
import AnimationButton from "../structured-text/blocks/animation-button";

const ArticleCard = (props) => {
    return (
        <div className={`card card--article${props.catalogue?.url ? ' card--download' : ''}`}>
            <div className='card--article__image'>
                {(props.featureImage || props.thumbnail) && <Asset asset={props.thumbnail ? props.thumbnail : props.featureImage}/>}
            </div>
            <div className='card--article__tag'>
              {props.categories.length > 0 && props.categories.slice(0, 2).map((category, i) => (
                <Link to={`/news/?category=${category.title}`}><span>{category.title}</span></Link>
            ))}
            </div>
            {props.title && <h4>{parse(props.title)}</h4>}
            {props.excerpt && <p>{props.excerpt}</p>}
            {props.permalink &&
                <AnimationButton className='btn btn--animation' to={props.catalogue?.url ? props.catalogue.url : props.permalink}>
                    {props.categories[0].title === 'Instructional Video' && <SolidPlay color='#19419E'/>}
                    {props.categories[0].title !== 'Product Catalogues' && props.categories[0].title !== 'Instructional Video' && <RightArrow color='#19419E'/>}
                    {props.categories[0].title === 'Product Catalogues' && <Download color='#19419E'/>}
                </AnimationButton>
            }
        </div>
    )
}

export default ArticleCard